import { IDictionary, WidgetAttributes } from '../../../../packages/types';

import { lineupsAttributes } from './Lineups';
import { oddsAttributes } from './Odds';
import { teamH2hAttributes } from './TeamH2hWidget';
import { playerH2hAttributes } from './PlayerH2h';
import { teamSquadAttributes } from './TeamSquad';
import { knockoutAttributes } from './Knockout';
import { livescoreAttributes } from './Livescore';
import { playerAttributes } from './Player';
import { programmeAttributes } from './Programme';
import { tournamentProgrammeAttributes } from './TournamentProgramme';
import { singleEventAttributes } from './SingleEvent';
import { standingsAttributes } from './Standings';
import { teamAttributes } from './Team';
import { topScorersAttributes } from './TopScorers';
import { mostDecoratedAttributes } from './MostDecorated';
import { matchesH2HAttributes } from './MatchesH2H';
import { stakesAttributes } from './Stakes';
import { teamMatchH2hAttributes } from './TeamMatchH2HWidget';
import { matchCenterAttributes } from './MatchCenter';
import { timelineAttributes } from './Timeline';
import { roundAttributes } from './Round';

const attributes: IDictionary<WidgetAttributes> = {
  ...timelineAttributes,
  ...matchCenterAttributes,
  ...stakesAttributes,
  ...lineupsAttributes,
  ...oddsAttributes,
  ...teamH2hAttributes,
  ...playerH2hAttributes,
  ...teamSquadAttributes,
  ...knockoutAttributes,
  ...livescoreAttributes,
  ...playerAttributes,
  ...programmeAttributes,
  ...tournamentProgrammeAttributes,
  ...singleEventAttributes,
  ...standingsAttributes,
  ...teamAttributes,
  ...topScorersAttributes,
  ...mostDecoratedAttributes,
  ...matchesH2HAttributes,
  ...teamMatchH2hAttributes,
  ...roundAttributes,
};

/** Export widgets */
export * from './Timeline';
export * from './MatchCenter';
export * from './Stakes';
export * from './Lineups';
export * from './Odds';
export * from './TeamH2hWidget';
export * from './PlayerH2h';
export * from './TeamSquad';
export * from './Knockout';
export * from './Livescore';
export * from './Player';
export * from './Programme';
export * from './TournamentProgramme';
export * from './SingleEvent';
export * from './Standings';
export * from './Team';
export * from './TopScorers';
export * from './MostDecorated';
export * from './MatchesH2H';
export * from './TeamMatchH2HWidget';
export * from './Round';

export { attributes };
